<template>
  <div class="form_warpper">
    <div class="login-title">
      <div class="tabs">
        <div class="tabs-content">
          <el-tabs v-if="title !== '注册' && title !== '忘记密码'" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="密码登录" name="1"> </el-tab-pane>
            <!-- <el-tab-pane label="验证码登录" name="2" before-leave></el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>
    <el-form :model="loginForm" :rules="loginRoules" ref="loginForm" label-width="0px" class="login-content">
      <div v-if="activeName === '1'" class="passwordLogin">
        <el-form-item prop="username">
          <input class="login-user" v-model="loginForm.username" placeholder="请输入手机号" type="text">
        </el-form-item>
        <slot name="forget"></slot>
        <el-form-item prop="password">
          <input class="login-pass" v-model="loginForm.password" placeholder="请输入密码" type="password">
        </el-form-item>
        <el-form-item prop="password" v-if="isRegister">
          <input class="login-pass" v-model="loginForm.againPassword" placeholder="请再次输入密码" type="password">
        </el-form-item>
        <el-form-item prop="imgCaptcha">
          <div class="captcha">
            <input class="login-captcha" v-model="loginForm.imgCaptcha" placeholder="请输入图形验证码" type="te">
            <div class="captcha-img">
              <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="getImgUrl" @click="handleChangeCheckCode" />
              <img v-else src="../../assets/images/checkcode.png" @click="handleChangeCheckCode" />
            </div>
          </div>

        </el-form-item>
        <slot name="termHandle"></slot>
        <slot name="code"></slot>

        <!-- <el-form-item prop="imgCaptcha" v-if="title!=='注册' && title!=='忘记密码'" class="input_code">
          <el-input v-model="loginForm.imgCaptcha" size="large" type="text"  placeholder="请输入图形验证码"></el-input>
        </el-form-item>
        <el-form-item prop="imgCaptcha" v-if="title!=='注册' && title!=='忘记密码'" class="image_code">
          <el-image :src="getImgUrl" @click="handleChangeCheckCode"></el-image>
        </el-form-item> -->
      </div>
      <div v-else class="captchaLogin">
        <el-form-item prop="username">
          <input class="login-user" v-model="loginForm.username" placeholder="请输入手机号" type="text">
        </el-form-item>
        <el-form-item prop="loginCaptcha">
          <div class="captcha-item">
            <input class="login-pass" v-model="loginForm.loginCaptcha" placeholder="请输入验证码" type="text">
            <el-button size="mini" class="get-captcha" @click="getPhoneCaptcha" :disabled="sendCodeBtnDisable">
              {{ seconds || '获取验证码' }}</el-button>
          </div>
        </el-form-item>
      </div>
      <slot name="loginBtn"></slot>
      <div class="footer">
        <!-- <el-button :disabled="activeName !== '1'" class="forgot" type="text" @click="onAlign('2')" v-show="align2">{{align2}}</el-button> -->
        <el-button class="submit" type="primary" @click="loginHandle('loginForm')">{{ submit }}</el-button>
        <!-- <el-button class="align" type="primary" @click="onAlign('1')" v-show="align">{{align}}</el-button> -->
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDoctorCaptcha } from "@/api";
export default {
  name: "InfoFrom",
  components: {},
  props: {
    title: String,
    fromType: String,
    submit: String,
    align: String,
    align2: String,
    lock: String,
    isRegister: Boolean
  },
  data() {
    return {

      getImgUrl: '',
      requestCodeSuccess: false,
      loginForm: {
        username: "",
        password: "",
        imgCaptcha: "",
        loginCaptcha: '',
        againPassword: "",

      },
      loginRoules: {
        username: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        imgCaptcha: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
        // loginCaptcha: [
        //   {
        //     required: true,
        //     message: "请输入验证码",
        //     trigger: "blur"
        //   }
        // ],
        // registerCaptcha: [
        //   {
        //     required: true,
        //     message: "请输入验证码",
        //     trigger: "blur"
        //   }
        // ]
      },
      activeName: '1',
      seconds: 0,  //短信验证码读秒
      sendCodeBtnDisable: false
    };
  },
  mounted() {
    this.handleChangeCheckCode();
  },
  methods: {
    loginHandle(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let userInfo = this.loginForm;
          this.$emit("on-submit", userInfo);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onAlign(type) {
      this.$emit('on-align', type)
    },
    handleClick(tab, event) {
      if (tab.name == '1') {
        this.loginForm.loginCaptcha = ''
      } else {
        this.loginForm.imgCaptcha = ''
      }
    },
    //获取手机验证码登录
    async getPhoneCaptcha() {
      if (this.loginForm.username === "") {
        this.elementTips("error", "手机号码不能为空");
        return;
      }
      let isPhone = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/.test(
        this.loginForm.username
      );
      if (!isPhone) {
        this.elementTips("error", "手机格式不正确");
        return;
      }
      const params = {
        mobile: this.loginForm.username,
        smsMode: '1'
      };
      let res = await getCaptcha(params);
      const { code, message } = res

      if (code === 200) {
        this.countDown();
        this.elementTips("success", message);
        this.sendCodeBtnDisable = true;
      } else {
        this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
        this.elementTips("warning", message);
      }

    },
    countDown() {
      this.seconds = 60
      this.secondsTimeId = setInterval(() => {
        if (this.seconds > 0 && this.seconds <= 60) {
          this.seconds--
        } else {
          clearInterval(this.secondsTimeId)
          this.seconds = 0
          this.sendCodeBtnDisable = false
        }
      }, 1000)
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },

    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    async handleChangeCheckCode() {
      try {
        this.currdatetime = new Date().getTime();
        const params = {
          key: this.currdatetime,
        };
        let { code, data } = await getDoctorCaptcha(params);
        if (code === 1) {
          this.getImgUrl = data.captcha
          this.loginForm.salt = data.salt
          this.loginForm.checkKey = this.currdatetime
          this.requestCodeSuccess = true
        } else {
          this.$message.error(message)
          this.requestCodeSuccess = false
        }
      } catch (error) {
        this.requestCodeSuccess = false
      }
    },
  },
  filter: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.passwordLogin {
  overflow: hidden;
}

.input_code {
  width: 60%;
  float: left;
}

.image_code {
  width: 35%;
  float: right;
}

.form_warpper {
  .login-title {
    width: 100%;
    text-align: center;
    line-height: 100%;
    font-weight: bold;
    font-size: 20px;
    margin-top: 5%;
    margin-left: 8%;
    color: #606266;
  }

  .login-title .tabs {
    display: flex;
    justify-content: center;
  }

  .login-captcha {
    border-style: none none none;
    border-bottom: 1px solid #dcdcdc;
    width: calc(100% - 60px);
    background-image: url("../../assets/images/login-code.png");
    background-size: 15px 15px;
    background-position: 4px 4px;
    background-repeat: no-repeat;
    padding: 5px 10px 6px 50px;
  }

  .captcha {
    position: relative;
  }

  .captcha-img {
    position: relative;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .captcha-item {
    position: relative;
  }

  .get-captcha {
    position: absolute;
    top: 7px;
    right: 0;
    background-color: #fff;
    color: #fc701a;
    border: none; // 去掉边框
    outline: none; // 去掉点击按钮后的边框
    cursor: pointer;
  }

  .login-content {
    padding: 8% 2% 2% 16%;

    .login-user {
      border-style: none none none;
      border-bottom: 1px solid #dcdcdc;
      width: calc(100% - 60px);
      background-image: url("../../assets/images/login-user.png");
      background-size: 15px 15px;
      background-position: 4px 4px;
      background-repeat: no-repeat;
      padding: 5px 10px 6px 50px;
    }

    .login-pass {
      border-style: none none none;
      border-bottom: 1px solid #dcdcdc;
      width: calc(100% - 60px);
      background-image: url("../../assets/images/login-pass.png");
      background-size: 15px 15px;
      background-position: 3px 4px;
      background-repeat: no-repeat;
      padding: 5px 10px 6px 50px;
    }

    .margin {
      margin-top: 18px;
    }
    .login-captcha:focus,
    .login-user:focus,
    .login-pass:focus {
      outline: none;
    }

    .loginBtn {
      text-align: end;

      button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
      }
    }

    .tip {
      font-size: 14px;
      color: #ddd;
    }

    .footer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      // margin-top: 8%;
      .submit {
        margin: 5px 0px 0px 0px;
        width: 100%;
        height: 50%;
        border: #fc701a 1px solid;
        background: #fc701a !important;
      }

      .align {
        margin: 5px 0px 0px 0px;
        width: 100%;
        height: 50%;
        color: #fc701a;
        border: #fc701a 1px solid;
        background: #ffffff !important;
      }

      .forgot {
        margin-left: calc(100% - 58px);
        position: relative;
        bottom: 10px;
        color: #fc701a !important;
      }
    }
  }
}

/deep/ .el-form-item {
  margin-bottom: 18px;
}

input::-webkit-input-placeholder {
  color: #c0c0c0;
  font-size: 14px;
}
</style>